module.exports = __webpack_public_path__ + "img/zona1.818088cc.jpg";